import CheckoutDetail from '../views/features/dashboard/orders/checkout-detail';
/* eslint-disable @typescript-eslint/no-unused-vars */
import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { Loading } from '../views/components';
import { DashboardLayout } from '../views/components/layouts';
import CreateNewOrder from '../views/features/dashboard/orders/create';
import FoodItemsScreen from '../views/features/dashboard/food-items';
import MarketingCategories from '../views/features/dashboard/categories/marketing-categories';
import Cashback from '../views/features/dashboard/coupons/cashback';
import VendorKitchens from '../views/features/dashboard/kitchens/vendor-kitchens';
import { RefundConfigurations } from '../views/features/dashboard/refund-configuration';

const DashboardHome = lazy(() => import('../views/features/dashboard/home'));
const NotFound = lazy(() => import('../views/features/dashboard/not-found'));
const Brand = lazy(() => import('../views/features/dashboard/brands/brand'));

const Brands = lazy(() => import('../views/features/dashboard/brands/brands'));

const Categories = lazy(
  () => import('../views/features/dashboard/categories/categories')
);

const Category = lazy(
  () => import('../views/features/dashboard/categories/category')
);

const CreateKitchen = lazy(
  () => import('../views/features/dashboard/kitchens/createKitchen')
);

const Kitchens = lazy(
  () => import('../views/features/dashboard/kitchens/kitchens')
);

const Variants = lazy(
  () => import('../views/features/dashboard/variants/variants')
);

const Meal = lazy(() => import('../views/features/dashboard/meals/meal'));

const Meals = lazy(() => import('../views/features/dashboard/meals/meals'));

const CreateOrder = lazy(
  () => import('../views/features/dashboard/orders/createOrder')
);

const Order = lazy(() => import('../views/features/dashboard/orders/order'));

const Orders = lazy(() => import('../views/features/dashboard/orders/orders'));

const ThirdPartyOrders = lazy(
  () => import('../views/features/dashboard/orders/third-party-orders')
);

const CreateMeal = lazy(
  () => import('../views/features/dashboard/meals/createMeal')
);

const Users = lazy(() => import('../views/features/dashboard/users'));

const DeliveryPage = lazy(() => import('../views/features/dashboard/delivery'));
const Pilots = lazy(() => import('../views/features/dashboard/pilots/pilots'));

const Pilot = lazy(() => import('../views/features/dashboard/pilots/pilot'));

const CreatePilot = lazy(
  () => import('../views/features/dashboard/pilots/createPilot')
);

const CreateBrand = lazy(
  () => import('../views/features/dashboard/brands/createBrand')
);

const CreateUser = lazy(
  () => import('../views/features/dashboard/users/createUser')
);

const User = lazy(() => import('../views/features/dashboard/users/user'));

const Customers = lazy(
  () => import('../views/features/dashboard/customers/customers')
);

const Promotions = lazy(
  () => import('../views/features/dashboard/promotions/promotions')
);

const Promotion = lazy(
  () => import('../views/features/dashboard/promotions/promotion')
);

const CreatePromotion = lazy(
  () => import('../views/features/dashboard/promotions/createPromotion')
);

const Transactions = lazy(
  () => import('../views/features/dashboard/transactions')
);

const WalletTransactions = lazy(
  () => import('../views/features/dashboard/wallet-transactions')
);

const Addresses = lazy(() => import('../views/features/dashboard/addresses'));

const Coupons = lazy(() => import('../views/features/dashboard/coupons'));

const Coupon = lazy(() => import('../views/features/dashboard/coupons/coupon'));

const CashbackConfig = lazy(
  () => import('../views/features/dashboard/coupons/cashbackConfig')
);

const CreateCoupon = lazy(
  () => import('../views/features/dashboard/coupons/create')
);

const CreateCashback = lazy(
  () => import('../views/features/dashboard/coupons/createCashback')
);

const AbandonedCheckout = lazy(
  () => import('../views/features/dashboard/abandoned-checkout')
);

const Branches = lazy(() => import('../views/features/dashboard/branches'));
const CreateBranch = lazy(
  () => import('../views/features/dashboard/branches/create')
);
const UpdateBranch = lazy(
  () => import('../views/features/dashboard/branches/update')
);
const BranchesByBrand = lazy(
  () => import('../views/features/dashboard/branches/by-brand')
);

const BrandReviews = lazy(
  () => import('../views/features/dashboard/brands/brandReviews')
);

const GiftCards = lazy(() => import('../views/features/dashboard/gift-cards'));

const GiftCardDesigns = lazy(
  () => import('../views/features/dashboard/gift-card-designs')
);

const LoyaltyProgram = lazy(
  () => import('../views/features/dashboard/loyalty')
);

const CreateLoyaltyTier = lazy(
  () => import('../views/features/dashboard/loyalty/create-loyalty-tier')
);

const FlaggedOrders = lazy(
  () => import('../views/features/dashboard/orders/flagged-orders')
);

const LocationExclusions = lazy(
  () => import('../views/features/dashboard/location/LocationExclusions')
);

const DeliveryRatesScreen = lazy(
  () => import('../views/features/dashboard/delivery-rates/delivery-rates')
);

const KitchenDeliveryConfigScreen = lazy(
  () =>
    import(
      '../views/features/dashboard/kitchen-delivery-config/kitchen-delivery-config'
    )
);

const CreateKitchenConfigScreen = lazy(
  () =>
    import(
      '../views/features/dashboard/kitchen-delivery-config/create-kitchen-config'
    )
);

const CreateDeliveryRateScreen = lazy(
  () =>
    import('../views/features/dashboard/delivery-rates/create-delivery-rate')
);

const RidersAsService = lazy(
  () => import('../views/features/dashboard/riders-as-service')
);

const FilterConfig = lazy(
  () => import('../views/features/dashboard/filter-config')
);

const Settings = lazy(() => import('../views/features/dashboard/settings'));
const Outreaches = lazy(() => import('../views/features/dashboard/outreach'));
const CreateOutreach = lazy(
  () => import('../views/features/dashboard/outreach/create')
);
const OutreachDetail = lazy(
  () => import('../views/features/dashboard/outreach/outreach')
);

const Companies = lazy(
  () => import('../views/features/dashboard/platform/companies')
);
const OutletVendor = lazy(
  () => import('../views/components/brands/outlet-vendor')
);

const StockManagement = lazy(
  () => import('../views/features/dashboard/stock-management')
);

const StockDetail = lazy(
  () => import('../views/features/dashboard/stock-management/stock-detail')
);
const ProductDetail = lazy(
  () => import('../views/features/dashboard/stock-management/product-detail')
);
const Products = lazy(() => import('../views/features/dashboard/products'));
const PaymentsAnalytics = lazy(
  () => import('../views/features/dashboard/payments')
);
const SettlementDetail = lazy(
  () => import('../views/features/dashboard/payments/settlement-detail')
);
const Kitchen = lazy(
  () => import('../views/features/dashboard/kitchens/kitchen')
);

const ProductsTable = lazy(
  () => import('../views/features/dashboard/products/components/products-table')
);

const ProductParentsTable = lazy(
  () =>
    import(
      '../views/features/dashboard/products/components/product-parents-table'
    )
);

const ProductDetailView = lazy(
  () =>
    import(
      '../views/features/dashboard/products/components/product-detail-view'
    )
);

const ViewProducts = lazy(
  () => import('../views/features/dashboard/products/components/view-products')
);

const Collections = lazy(
  () => import('../views/features/dashboard/collections')
);
const AddCollection = lazy(
  () => import('../views/features/dashboard/collections/add-collection')
);
const ProductOrganization = lazy(
  () => import('../views/features/dashboard/product-organization')
);

const CreateDepartment = lazy(
  () =>
    import('../views/features/dashboard/product-organization/create-department')
);
const CreateCategory = lazy(
  () =>
    import('../views/features/dashboard/product-organization/create-category')
);
export const DashboardRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <DashboardLayout>
        <Suspense fallback={<div />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        path: 'vendors',
        element: <Brands />,
        children: [
          { path: ':brandSlug/vendor-ratings', element: <BrandReviews /> },
        ],
      },
      {
        path: 'vendors/create',
        element: <CreateBrand />,
      },
      {
        path: 'vendors/edit/:slug',
        element: <CreateBrand />,
      },
      {
        path: 'vendors/:brandSlug',
        element: <Brand />,
      },

      {
        path: 'variants',
        element: <Variants />,
      },
      {
        path: '/variants/:variantSlug',
        element: <Brand />,
      },

      {
        path: 'outlets',
        element: <Kitchens />,
      },
      {
        path: 'outlets/create',
        element: <CreateKitchen />,
      },
      {
        path: 'outlets/edit/:id',
        element: <CreateKitchen />,
      },
      {
        path: 'outlets/:kitchenId',
        element: <Kitchen />,
      },
      {
        path: 'vendor-kitchens',
        element: <VendorKitchens />,
      },

      {
        path: 'stock-management',
        element: <StockManagement />,
      },
      {
        path: 'stock-management/:id',
        element: <StockDetail />,
      },
      {
        path: 'stock-management/:id/product/:productId',
        element: <ProductDetail />,
      },

      {
        path: 'vendors/:slug/outlet-vendors',
        element: <OutletVendor />,
      },

      {
        path: 'products',
        element: <Products />,
      },
      {
        path: 'products/:slug',
        element: <ProductsTable />,
      },
      {
        path: 'products/:slug/parents',
        element: <ProductParentsTable />,
      },
      {
        path: 'products/:slug/detail/:productId',
        element: <ProductDetailView />,
      },
      {
        path: 'products/view',
        element: <ViewProducts />,
      },
      {
        path: 'collections',
        element: <Collections />,
      },
      {
        path: 'collections/add',
        element: <AddCollection />,
      },
      {
        path: 'collections/edit/:id',
        element: <AddCollection />,
      },
      {
        path: 'product-organization',
        element: <ProductOrganization />,
      },
      {
        path: 'product-organization/create-department',
        element: <CreateDepartment />,
      },
      {
        path: 'product-organization/create-department/:mode/:id',
        element: <CreateDepartment />,
      },
      {
        path: 'product-organization/create-category',
        element: <CreateCategory />,
      },
      {
        path: 'product-organization/edit-category/:id',
        element: <CreateCategory />,
      },
      {
        path: 'payments',
        element: <PaymentsAnalytics />,
      },
      {
        path: 'payments/:payoutId',
        element: <SettlementDetail />,
      },

      {
        path: 'meals',
        element: <Meals />,
      },
      {
        path: '/meal/:mealSlug',
        element: <Meal />,
      },
      {
        path: 'meals/:action',
        element: <CreateMeal />,
        children: [{ path: ':slug', element: <CreateMeal /> }],
      },

      {
        path: 'orders',
        element: <Orders />,
      },
      {
        path: '3rd-party-orders',
        element: <ThirdPartyOrders />,
      },
      {
        path: 'flagged-orders',
        element: <FlaggedOrders />,
      },
      {
        path: '/checkout/:slug',
        element: <CheckoutDetail />,
      },
      {
        path: '/order/:orderId',
        element: <Order />,
      },
      {
        path: 'orders/:action',
        element: <CreateOrder />,
        children: [{ path: ':id', element: <CreateOrder /> }],
      },
      {
        path: 'orders/create',
        element: <CreateNewOrder />,
      },

      {
        path: 'categories',
        element: <Categories />,
      },
      {
        path: 'marketing-categories',
        element: <MarketingCategories />,
      },
      {
        path: 'categories/:categorySlug',
        element: <Category />,
      },
      {
        path: 'home',
        element: <DashboardHome />,
      },
      {
        path: 'users',
        element: <Users />,
      },
      {
        path: '/user/:userId',
        element: <User />,
      },
      {
        path: 'users/:action',
        element: <CreateUser />,
        children: [{ path: ':id', element: <CreateUser /> }],
      },

      {
        path: 'customers',
        element: <Customers />,
      },
      {
        path: '/customer/:userId',
        element: <User />,
      },
      {
        path: 'customers/:action',
        element: <CreateUser />,
        children: [{ path: ':id', element: <CreateUser /> }],
      },

      {
        path: 'delivery',
        element: <DeliveryPage />,
      },
      {
        path: 'pilots',
        element: <Pilots />,
      },
      {
        path: 'pilots/:action',
        element: <CreatePilot />,
        children: [{ path: ':id', element: <CreatePilot /> }],
      },
      {
        path: 'pilot/:id',
        element: <Pilot />,
      },

      {
        path: 'riders-as-service',
        element: <RidersAsService />,
      },

      {
        path: 'filter-config',
        element: <FilterConfig />,
      },

      {
        path: '/',
        element: <DashboardHome />,
      },

      {
        path: 'promotions',
        element: <Promotions />,
      },
      {
        path: 'promotion/:id',
        element: <Promotion />,
      },
      {
        path: 'promotions/:action',
        element: <CreatePromotion />,
        children: [{ path: ':id', element: <CreatePromotion /> }],
      },

      {
        path: 'transactions',
        element: <Transactions />,
      },

      {
        path: 'wallet-transactions',
        element: <WalletTransactions />,
      },

      {
        path: 'addresses',
        element: <Addresses />,
      },

      {
        path: 'location/exclusions',
        element: <LocationExclusions />,
      },

      {
        path: 'coupons',
        element: <Coupons />,
      },
      {
        path: 'coupon/:slug',
        element: <Coupon />,
      },
      {
        path: 'coupons/cashback-config',
        element: <CashbackConfig />,
      },
      {
        path: 'coupons/cashback/create',
        element: <CreateCashback />,
      },
      {
        path: 'coupons/cashback/edit/:id',
        element: <CreateCashback />,
      },
      {
        path: 'coupons/cashback/:cashbackId',
        element: <Cashback />,
      },
      {
        path: 'coupons/:action',
        element: <CreateCoupon />,
        children: [{ path: ':slug', element: <CreateCoupon /> }],
      },

      {
        path: 'abandoned-checkout',
        element: <AbandonedCheckout />,
      },

      {
        path: 'branches',
        element: <Branches />,
      },
      {
        path: 'brand/:brandId/branches',
        element: <BranchesByBrand />,
      },
      {
        path: 'branch/create',
        element: <CreateBranch />,
      },
      {
        path: 'branch/edit/:id',
        element: <UpdateBranch />,
      },

      {
        path: 'gift-cards',
        element: <GiftCards />,
      },

      {
        path: 'gift-card-designs',
        element: <GiftCardDesigns />,
      },

      {
        path: 'products',
        element: <FoodItemsScreen />,
      },
      {
        path: 'products/:action',
        element: <FoodItemsScreen />,
        children: [{ path: ':id', element: <FoodItemsScreen /> }],
      },

      {
        path: 'loyalty-program',
        element: <LoyaltyProgram />,
      },
      {
        path: 'loyalty-program/create',
        element: <CreateLoyaltyTier />,
      },

      {
        path: 'delivery-rates',
        element: <DeliveryRatesScreen />,
      },
      {
        path: 'delivery-rates/create',
        element: <CreateDeliveryRateScreen />,
      },
      {
        path: 'delivery-rates/edit',
        element: <CreateDeliveryRateScreen />,
      },
      {
        path: 'outlet-configurations',
        element: <KitchenDeliveryConfigScreen />,
      },
      {
        path: 'outlet-configurations/create',
        element: <CreateKitchenConfigScreen />,
      },
      {
        path: 'outlet-configurations/edit',
        element: <CreateKitchenConfigScreen />,
      },

      {
        path: 'refund-configurations',
        element: <RefundConfigurations />,
      },
      {
        path: 'outreach',
        element: <Outreaches />,
      },
      {
        path: 'outreach/create',
        element: <CreateOutreach />,
      },
      {
        path: 'outreach/:id',
        element: <OutreachDetail />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
      {
        path: 'platform/companies',
        element: <Companies />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];
